import React from 'react'
import { Card } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const CaptableManagementMapSkeleton = () => {
    return (
        <div className='d-flex w-100'>
            <Card
                className='w-75 p-8 pt-4 px-4 bg-white'
                style={{ borderBottomRightRadius: '0px', borderTopRightRadius: '0px' }}
            >
                <Skeleton
                    width={120}
                    height={20}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
                <div>
                    <div className='bg-transparent p-md-4 pb-md-0 rounded-2 '>
                        <div>
                            <Skeleton
                                width={400}
                                height={200}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <Card
                className='w-25 d-flex justify-content-center bg-white'
                style={{ borderBottomLeftRadius: '0px', borderTopLeftRadius: '0px' }}
            >
                <div className='d-flex flex-row align-items-center justify-content-between mt-3'>
                    <div className=''>
                        <div className='d-flex justify-content-between align-items-center font-size-8 mb-1 gap-12'>
                            <Skeleton
                                width={120}
                                height={20}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                        </div>
                        <div className='d-flex justify-content-between align-items-center font-size-8 mb-1 gap-12'>
                            <Skeleton
                                width={120}
                                height={20}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default CaptableManagementMapSkeleton
